import React from 'react';
import {Text, View} from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import {
  tooltipGradientColors,
  tooltipRadius,
  tooltipText,
  tooltipWidth
} from '../../../style/adminTools';

export const TooltipBubble = ({text, testID, align = 'left'}) => (
  <LinearGradient
    colors={tooltipGradientColors}
    testID={testID}
    style={{
      position: 'absolute',
      top: '100%',
      marginTop: 6,
      [align]: 0,
      width: tooltipWidth,
      padding: 10,
      borderRadius: tooltipRadius,
      zIndex: 1000
    }}
  >
    <Text accessibilityRole="text" style={tooltipText}>
      {text}
    </Text>
  </LinearGradient>
);

export const TooltipAnchor = ({children}) => (
  <View style={{position: 'relative'}}>{children}</View>
);
